module.exports = __webpack_public_path__ + "static/media/orange_mark_icon.57fe6009.svg";